import { LedgerComparison } from "@/features/oversight/reconciliation";

export default function ReconciliationLedgerComparisonPage() {
  return <LedgerComparison />;
}